import React from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';

import { setMonthType, setWeekType, setDayType, setHabitMonth } from '~/Redux/Modules/DateRange';
import { toggle } from '~/Redux/Modules/StickerPacksUi';
import { MONTH, WEEK, DAY, HABIT } from '~/Config/DateRangeTypes';

import history from '~/Providers/History';
import moment from '~/Providers/Moment';
import AppFeatureView, { HABIT_TRACKER } from '~/Components/Global/AppFeatureView';

import './DateTabs.scss';

const DateTabs = ({
  children,
  monthView,
  weekView,
  dayView,
  habitView,
  currentType,
  currentMonth,
  currentWeek,
  currentDay,
  toggleStickers,
  stickersOpen,
}) => {
  const isList = history.location.pathname.startsWith('/lists');
  const isHabitTabActive = currentType === HABIT;
  return (
    <div className="date-tabs-wrapper">
      <AppFeatureView
        featureName={HABIT_TRACKER}
        disabledView={
          <>
            <div
              className={`tab tab-right tab-1 ${!isList && currentType === MONTH ? 'active' : ''}`}
              onClick={() => monthView(currentMonth, currentType)}
            >
              MONTH
            </div>
            <div
              className={`tab tab-right tab-2 ${!isList && currentType === WEEK ? 'active' : ''}`}
              onClick={() => {
                weekView(currentWeek, currentType);
              }}
            >
              WEEK
            </div>
            <div
              className={`tab tab-right tab-3 ${!isList && currentType === DAY ? 'active' : ''}`}
              onClick={() => dayView(currentDay, currentType)}
            >
              DAY
            </div>
            {!isList && (
              <div
                className={`tab tab-left tab-4 ${stickersOpen ? 'active' : ''}`}
                onClick={() => toggleStickers(!stickersOpen)}
              >
                STICKERS
              </div>
            )}
            <div
              onClick={() => history.push('/lists')}
              className={`tab tab-left tab-5 ${isList ? 'active' : ''}`}
            >
              LISTS
            </div>
          </>
        }
      >
        <div
          className={`tab tab-right tab-1 feature-flag ${
            !isList && currentType === MONTH ? 'active' : ''
          }`}
          onClick={() => monthView(currentMonth, currentType)}
        >
          MONTH
        </div>
        <div
          className={`tab tab-right tab-2 feature-flag ${
            !isList && currentType === WEEK ? 'active' : ''
          }`}
          onClick={() => {
            weekView(currentWeek, currentType);
          }}
        >
          WEEK
        </div>
        <div
          className={`tab tab-right tab-3 feature-flag ${
            !isList && currentType === DAY ? 'active' : ''
          }`}
          onClick={() => dayView(currentDay, currentType)}
        >
          DAY
        </div>
        {!isList && !isHabitTabActive && (
          <div
            className={`tab tab-left tab-4-feature-flag ${stickersOpen ? 'active' : ''}`}
            onClick={() => toggleStickers(!stickersOpen)}
          >
            STICKERS
          </div>
        )}
        <div
          onClick={() => history.push('/lists')}
          className={`tab tab-left tab-5-feature-flag ${isList ? 'active' : ''}`}
        >
          LISTS
        </div>
        <div
          className={`tab tab-left tab-6-feature-flag ${
            !isList && isHabitTabActive ? 'active' : ''
          }`}
          onClick={() => {
            habitView(currentMonth, currentType);
          }}
        >
          HABITS
        </div>
      </AppFeatureView>
      {children}
    </div>
  );
};

DateTabs.propTypes = {
  children: propTypes.node,
  currentType: propTypes.string,
  monthView: propTypes.func,
  weekView: propTypes.func,
  dayView: propTypes.func,
  habitView: propTypes.func,
  stickersOpen: propTypes.bool,
  toggleStickers: propTypes.func,
  currentMonth: propTypes.object,
  currentWeek: propTypes.object,
  currentDay: propTypes.object,
};

const mapStateToProps = ({ DateRange, StickerPacksUi }) => {
  return {
    stickersOpen: StickerPacksUi.tabOpen,
    currentType: DateRange.currentType,
    currentDay: DateRange.pin,
    currentWeek: DateRange.pin.clone().startOf(WEEK),
    currentMonth: DateRange.pin.clone().startOf(MONTH),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    monthView: (monthStart, currentType) =>
      currentType === MONTH
        ? dispatch(setMonthType(moment().startOf('month')))
        : dispatch(setMonthType(monthStart.clone())),
    weekView: (weekStart, currentType) => {
      return currentType === WEEK
        ? dispatch(setWeekType(moment().startOf('week')))
        : dispatch(setWeekType(weekStart.clone()));
    },
    dayView: (currentDay, currentType) =>
      currentType === DAY
        ? dispatch(setDayType(moment().startOf('day')))
        : dispatch(setDayType(currentDay.clone())),
    habitView: (monthStart, currentType) => {
      console.log(`habitView currentType: ${currentType}`);
      return currentType === HABIT
        ? dispatch(setHabitMonth(moment().startOf('month')))
        : dispatch(setHabitMonth(monthStart.clone()));
    },
    toggleStickers: update => dispatch(toggle(update)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DateTabs);
